import React from 'react';
import './BlogCard.css';

const BlogCard = ({ post }) => {
    const { title, body, blogURL } = post
    return (
        <div className="card m-2">
            <div className="card-body">
                <h4 className="card-title" style={{ color: '#45a29e' }}>{title}</h4>
                <p className="card-text lead">{body}... <a target="blank" href={blogURL} className="card-link" style={{ textDecoration: 'none', color: '#45a29e' }}>See More</a></p>
            </div>
        </div>
    );
};

export default BlogCard;